import { Card, Drawer, Form, Button, notification } from "antd";
import React from "react";
import { connect } from "react-redux";
import { FormUtils as GetAllFormFields } from "sz-react-utils";
import Request, { LAPI_URL } from "../../request";
import _ from 'lodash';


let details = {
    documents: "/documents",
    claim: '/desk/getClaim'
}

@Form.create()
class InquiryReviewDrawer extends React.Component {
    state = {
        visible: true,
        loading: false
    }

    onClose = () => {
        setTimeout(() => {
            this.props.onClose();
        });
    }

    handleSubmit = async (e) => {
        e.preventDefault();

        let { form, details: { _id } } = this.props;

        form.validateFieldsAndScroll(async (err, valData) => {
            if (err) return;

            const requiredFields = [
                'studentRecord',
                'intakeDate',
                'tutionFeeAmount',
                'tutionFeePayment',
                'universityOrCPinformation',
                'branchOrApinformation',
                'swiftCopy',
                'piInvoiceCount',
                'piInvoiceAmount'
            ];
            // check if all values are truthy
            let allVerified = requiredFields.every(key => valData[key] === true);

            valData.reviewStatus = allVerified ? 'Verified' : 'Under Review';

            let values = {
                _id,
                valData: { invoiceReviewDetails: _.clone(valData) }
            }

            this.setState({ loading: true });

            let response = await Request.updateInquiry(values);

            this.setState({ loading: false });

            if (response.success) {
                notification.success({
                    message: response.msg
                });
            } else {
                notification.error({
                    message: response.msg
                });
            }

            this.onClose();
        });
    }


    // handleSubmit = async (e) => {
    //     e.preventDefault();
    //     let { form, details: { _id } } = this.props;
    //     form.validateFieldsAndScroll(async (err, valData) => {
    //         let values = {
    //             _id,
    //             valData: { invoiceReviewDetails: _.clone(valData) }
    //         }
    //         this.setState({ loading: true });
    //         let response = await Request.updateInquiry(values);
    //         this.setState({ loading: false });
    //         if (response.success) {
    //             notification.success({
    //                 message: response.msg
    //             })
    //         } else {
    //             notification.error({
    //                 message: response.msg
    //             })
    //         }

    //         this.onClose();
    //     })
    // }


    componentDidMount() {
        const { details, form } = this.props;

        if (details && details.invoiceReviewDetails) {
            const d = details.invoiceReviewDetails;
            setTimeout(() => {
                form.setFieldsValue({
                    // reviewStatus: d.reviewStatus,
                    studentRecord: d.studentRecord ? d.studentRecord : false,
                    intakeDate: d.intakeDate ? d.intakeDate : false,
                    tutionFeeAmount: d.tutionFeeAmount ? d.tutionFeeAmount : false,
                    tutionFeePayment: d.tutionFeePayment ? d.tutionFeePayment : false,
                    universityOrCPinformation: d.universityOrCPinformation ? d.universityOrCPinformation : false,
                    branchOrApinformation: d.branchOrApinformation ? d.branchOrApinformation : false,
                    swiftCopy: d.swiftCopy ? d.swiftCopy : false,
                    piInvoiceCount: d.piInvoiceCount ? d.piInvoiceCount : false,
                    piInvoiceAmount: d.piInvoiceAmount ? d.piInvoiceAmount : false,
                });
            }, 50)

        }
    }





    render() {
        let { visible } = this.state;
        let { details: { studentName, id, _id } } = this.props;
        let { form: { getFieldDecorator, setFieldsValue, getFieldValue } } = this.props;

        const inputTypes = {
            fields: [
                // {
                //     label: 'Review Status',
                //     key: 'reviewStatus',
                //     type: 'select',
                //     required: true,
                //     options: ['Under Review', 'Verified', 'Max Commission Paid'],
                //     onChange: v => {
                //         setFieldsValue({ reviewStatus: v });
                //     }
                // },
                {
                    label: (
                        <a
                            href={`${details.claim}?id=${_id}`}
                            target="_blank"
                            rel="noopener noreferrer"
                            onClick={e => e.stopPropagation()} // prevents toggling the switch
                        >
                            Student Record Verified
                        </a>
                    ),
                    key: 'studentRecord',
                    type: 'switch',
                    // required: getFieldValue('reviewStatus') !== 'Under Review',
                    // hidden: getFieldValue('reviewStatus') === 'Under Review',
                    onChange: v => {
                        setFieldsValue({ studentRecord: v });
                    }
                },
                {
                    label: (
                        <a
                            href={`${details.documents}?id=${_id}`}
                            target="_blank"
                            rel="noopener noreferrer"
                            onClick={e => e.stopPropagation()} // prevents toggling the switch
                        >
                            Intake Date Verified
                        </a>
                    ),
                    key: 'intakeDate',
                    type: 'switch',
                    // required: getFieldValue('reviewStatus') !== 'Under Review',
                    // hidden: getFieldValue('reviewStatus') === 'Under Review',
                    onChange: v => {
                        setFieldsValue({ intakeDate: v });
                    }
                },
                {
                    label: (
                        <a
                            href={`${details.documents}?id=${_id}`}
                            target="_blank"
                            rel="noopener noreferrer"
                            onClick={e => e.stopPropagation()} // prevents toggling the switch
                        >
                            Tuition Fee Amount Verified
                        </a>
                    ),
                    key: 'tutionFeeAmount',
                    type: 'switch',
                    // required: getFieldValue('reviewStatus') !== 'Under Review',
                    // hidden: getFieldValue('reviewStatus') === 'Under Review',
                    onChange: v => {
                        setFieldsValue({ tutionFeeAmount: v });
                    }
                },
                {
                    label: (
                        <a
                            href={`${details.documents}?id=${_id}`}
                            target="_blank"
                            rel="noopener noreferrer"
                            onClick={e => e.stopPropagation()} // prevents toggling the switch
                        >
                            Tuition Fee Payment Verified
                        </a>
                    ),
                    key: 'tutionFeePayment',
                    type: 'switch',
                    // required: getFieldValue('reviewStatus') !== 'Under Review',
                    // hidden: getFieldValue('reviewStatus') === 'Under Review',
                    onChange: v => {
                        setFieldsValue({ tutionFeePayment: v });
                    }
                },
                {
                    label: (
                        <a
                            href={`${details.documents}?id=${_id}`}
                            target="_blank"
                            rel="noopener noreferrer"
                            onClick={e => e.stopPropagation()} // prevents toggling the switch
                        >
                            University / CP Information Verified
                        </a>
                    ),
                    key: 'universityOrCPinformation',
                    type: 'switch',
                    // required: getFieldValue('reviewStatus') !== 'Under Review',
                    // hidden: getFieldValue('reviewStatus') === 'Under Review',
                    onChange: v => {
                        setFieldsValue({ universityOrCPinformation: v });
                    }
                },
                {
                    label: (
                        <a
                            href={`${details.claim}?id=${_id}`}
                            target="_blank"
                            rel="noopener noreferrer"
                            onClick={e => e.stopPropagation()} // prevents toggling the switch
                        >
                            Branch / AP Information Verified
                        </a>
                    ),
                    key: 'branchOrApinformation',
                    type: 'switch',
                    // required: getFieldValue('reviewStatus') !== 'Under Review',
                    // hidden: getFieldValue('reviewStatus') === 'Under Review',
                    onChange: v => {
                        setFieldsValue({ branchOrApinformation: v });
                    }
                },
                {
                    label: (
                        <a
                            href={`${details.documents}?id=${_id}`}
                            target="_blank"
                            rel="noopener noreferrer"
                            onClick={e => e.stopPropagation()} // prevents toggling the switch
                        >
                            Swift Copy Verified
                        </a>
                    ),
                    key: 'swiftCopy',
                    type: 'switch',
                    // required: getFieldValue('reviewStatus') !== 'Under Review',
                    // hidden: getFieldValue('reviewStatus') === 'Under Review',
                    onChange: v => {
                        setFieldsValue({ swiftCopy: v });
                    }
                },
                {
                    label: (
                        <a
                            href={`${details.claim}?id=${_id}`}
                            target="_blank"
                            rel="noopener noreferrer"
                            onClick={e => e.stopPropagation()} // prevents toggling the switch
                        >
                            PI  Count Verified
                        </a>
                    ),
                    key: 'piInvoiceCount',
                    hidden: this.props.details && this.props.details.invoiceReviewDetails ? false : true,
                    type: 'switch',
                    // required: getFieldValue('reviewStatus') !== 'Under Review',
                    // hidden: getFieldValue('reviewStatus') === 'Under Review',
                    onChange: v => {
                        setFieldsValue({ piInvoiceCount: v });
                    }
                },
                {
                    label: (
                        <a
                            href={`${details.claim}?id=${_id}`}
                            target="_blank"
                            rel="noopener noreferrer"
                            onClick={e => e.stopPropagation()} // prevents toggling the switch
                        >
                            PI Amount Verified
                        </a>
                    ),
                    key: 'piInvoiceAmount',
                    hidden: this.props.details && this.props.details.invoiceReviewDetails ? false : true,
                    type: 'switch',
                    // required: getFieldValue('reviewStatus') !== 'Under Review',
                    // hidden: getFieldValue('reviewStatus') === 'Under Review',
                    onChange: v => {
                        setFieldsValue({ piInvoiceAmount: v });
                    }
                }
            ]
        };


        // const inputTypes = {
        //     fields: [
        //         {
        //             label: 'Review Status',
        //             key: 'reviewStatus',
        //             type: 'select',
        //             required: true,
        //             options: ['Under Review', 'Verified', 'Max Commission Paid'],
        //             onChange: v => {
        //                 setFieldsValue({
        //                     reviewStatus: v,
        //                 });
        //             }
        //         },
        //         {
        //             label: 'Student Record Verified',
        //             key: 'studentRecord',
        //             type: 'checkbox',
        //             required: getFieldValue('reviewStatus') !== "Under Review",
        //             hidden: getFieldValue('reviewStatus') === "Under Review"
        //         },
        //         {
        //             label: 'Intake Date Verified',
        //             key: 'intakeDate',
        //             type: 'checkbox',
        //             required: getFieldValue('reviewStatus') !== "Under Review",
        //             hidden: getFieldValue('reviewStatus') === "Under Review"
        //         },
        //         {
        //             label: 'Tuition Fee Amount Verified',
        //             key: 'tutionFeeAmount',
        //             type: 'checkbox',
        //             required: getFieldValue('reviewStatus') !== "Under Review",
        //             hidden: getFieldValue('reviewStatus') === "Under Review"
        //         },
        //         {
        //             label: 'Tuition Fee Payment Verified',
        //             key: 'tutionFeePayment',
        //             type: 'checkbox',
        //             required: getFieldValue('reviewStatus') !== "Under Review",
        //             hidden: getFieldValue('reviewStatus') === "Under Review"
        //         },
        //         {
        //             label: 'University / CP Information Verified',
        //             key: 'universityOrCPinformation',
        //             type: 'checkbox',
        //             required: getFieldValue('reviewStatus') !== "Under Review",
        //             hidden: getFieldValue('reviewStatus') === "Under Review"
        //         },
        //         {
        //             label: 'Branch / AP Information Verified',
        //             key: 'branchOrApinformation',
        //             type: 'checkbox',
        //             required: getFieldValue('reviewStatus') !== "Under Review",
        //             hidden: getFieldValue('reviewStatus') === "Under Review"
        //         },
        //         {
        //             label: 'Swift Copy Verified',
        //             key: 'swiftCopy',
        //             type: 'checkbox',
        //             required: getFieldValue('reviewStatus') !== "Under Review",
        //             hidden: getFieldValue('reviewStatus') === "Under Review"
        //         },
        //         {
        //             label: 'PI Invoice Count Verified',
        //             key: 'piInvoiceCount',
        //             type: 'checkbox',
        //             required: getFieldValue('reviewStatus') !== "Under Review",
        //             hidden: getFieldValue('reviewStatus') === "Under Review"
        //         },
        //         {
        //             label: 'PI Invoice Amount Verified',
        //             key: 'piInvoiceAmount',
        //             type: 'checkbox',
        //             required: getFieldValue('reviewStatus') !== "Under Review",
        //             hidden: getFieldValue('reviewStatus') === "Under Review"
        //         },
        //     ]
        // };

        const drawerTitle = (
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', paddingRight: '20px' }}>
                <span>Review Details of {studentName} ({id})</span>
                <Button
                    type="default"
                    size="small"
                    icon="eye"
                    href={`/documents?id=${_id}`}
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    View All Documents
                </Button>
            </div>
        );

        return (
            <Drawer
                title={drawerTitle}
                placement="right"
                closable={true}
                onClose={this.onClose}
                visible={visible}
                width={800}
            >
                <Card bordered={true}>
                    <Form onSubmit={this.handleSubmit}>
                        <GetAllFormFields
                            inputSchema={inputTypes}
                            getFieldDecorator={getFieldDecorator}
                            apiurl={LAPI_URL}
                        />

                        <Button
                            style={{ marginBottom: 10 }}
                            type="primary"
                            htmlType="submit"
                            loading={this.state.loading}
                        >
                            SAVE
                        </Button>
                    </Form>
                </Card>
            </Drawer>
        )
    }
}




const mapStateToProps = ({ global, router }) => ({
    loading: global.buttonLoading,
    categories: global.categories,
    allChannelPartners: global.allChannelPartners,
    search: router.location.search
})

const mapDispatchToProps = dispatch => {
    return {
        dispatch
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(InquiryReviewDrawer)